"use client";

import { useState, useEffect } from "react";
import ScriptsDataTable from "@/components/user/scripts-data-table";
import { env } from "@/env";
import type { PaginatedScripts, Script } from "@/types/script";
import { useAuth } from "@/context/AuthContext";
import LoadingSpinner from "@/components/ui/loading-spinner";

export default function ScriptsPage() {
  const { user } = useAuth();
  const [scripts, setScripts] = useState<Script[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchScripts() {
      if (!user) return;

      try {
        const response = await fetch(
          `${env.NEXT_PUBLIC_API_URL}/user/${user.username}/posts`,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch scripts");
        }

        const data: PaginatedScripts = await response.json();
        setScripts(data.data.posts.result);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unexpected error occurred",
        );
      } finally {
        setLoading(false);
      }
    }

    fetchScripts();
  }, [user]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-heading text-lg font-medium">Scripts</h3>
        <p className="text-sm text-muted-foreground">
          Manage your scripts and automation settings.
        </p>
      </div>

      <hr className="border-t border-white/5" />

      <ScriptsDataTable scripts={scripts} />
    </div>
  );
}
